import React, { useEffect, useState } from 'react';
import {
  Table,
  Button,
  Form,
  Input,
  Select,
  DatePicker,
  Popconfirm,
  Space,
  Card,
} from 'antd';
import {
  PlusOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getSearchApi,
  getDataApi,
  getSearchApiFilters,
  getReceiptDocument,
  getSearchApiFilterDocstatus,
  getGetDetailsApi,
} from '../../../network/itemList';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getLandedCostVoucherItemsDerails } from '../../../network/landedCostVoucher';
import { getSupplier } from '../../../network/supplier';
import { getSearchPatients } from '../../../network/appointment';
const PurchaseReceipts = ({
  setDataSourcePurchase,
  selectedIndex,
  setSelectedIndex,
  watchDistributeCharges,
  dataSourcePurchase,
  t,
  setDataSourceItemList,
}) => {
  const [count, setCount] = useState(1);
  // console.log('dataSourcePurchase', dataSourcePurchase);
  const queryClient = useQueryClient();
  const [docId, setDocId] = useState('');
  const [searchTxtRec, setSearchTxtRec] = useState('');
  const [searchTxt, setSearchTxt] = useState('');
  const [docType, setDocType] = useState('');

  const filterPurchase = ['supplier', 'posting_date', 'base_grand_total'];
  const { data: choiceFrom } = useQuery({
    queryKey: [queryKeys.getSearchApiChoice, searchTxtRec],
    // queryFn: () => getSearchApi('Purchase Receipt'),
    queryFn: () =>
      getSearchApiFilterDocstatus('Purchase Receipt', searchTxtRec),
    enabled: searchTxtRec?.length >= 3 || searchTxtRec?.length === 0,
    keepPreviousData: true,
  });
  const { data: PurchaseInvoice } = useQuery({
    queryKey: [queryKeys.getSearchApPurchaseInvoice, searchTxt],
    queryFn: () => getSearchApiFilterDocstatus('Purchase Invoice'),
    enabled: searchTxt?.length >= 3 || searchTxt?.length === 0,
    keepPreviousData: true,
  });
  const { data: suppliers } = useQuery({
    queryKey: [queryKeys.getSupplier],
    queryFn: () =>
      getSupplier({
        key: '',
        value: '',
      }),
    keepPreviousData: true,
  });
  const { data: detailsItem } = useQuery({
    queryKey: [queryKeys.getLandedCostVoucherItemsDerails, docType, docId],
    queryFn: () => getLandedCostVoucherItemsDerails(docType, docId),
    keepPreviousData: true,
    enabled: docType !== '' && docId !== '',
  });
  const { mutate: handleGetDetails } = useMutation({
    mutationKey: [queryKeys.getSearchApiAccountList],
    mutationFn: (values) =>
      getGetDetailsApi({
        type: docType,
        name: values,
        fields: ['supplier', 'grand_total'],
      }),
    onSuccess: (data) => {
      console.log(data, 'data');
      const { supplier, grand_total } = data.message;
      setDataSourcePurchase((prevDataSource) => {
        const updatedDataSource = [...prevDataSource];
        updatedDataSource[selectedIndex] = {
          ...updatedDataSource[selectedIndex],
          supplier: supplier,
          grand_total: grand_total,
        };
        return updatedDataSource;
      });
    },
  });
  useEffect(() => {
    if (detailsItem?.message) {
      setDataSourcePurchase((prevDataSource) => {
        const updatedDataSource = [...prevDataSource];
        updatedDataSource[selectedIndex] = {
          ...updatedDataSource[selectedIndex],
          receipt_document_type: docType,
          receipt_document: docId,
          items: detailsItem.message?.map((newItemDetail) => ({
            ...newItemDetail,
            receipt_document_type: docType,
            receipt_document: docId,
            description: updatedDataSource[selectedIndex]?.description,
            id: updatedDataSource[selectedIndex]?.key,
          })),
        };
        return updatedDataSource;
      });
    }
  }, [detailsItem, setDataSourcePurchase]);

  const columns = [
    {
      title: t.receiptDocumentType,
      dataIndex: 'receipt_document_type',
      render: (text, record, index) => (
        <Select
          placeholder={t.receiptDocumentType}
          value={record.receipt_document_type}
          popupMatchSelectWidth={false}
          onChange={(value) => {
            setDocType(value);
            setSelectedIndex(index);
            const newDataSource = [...dataSourcePurchase];
            newDataSource[index] = {
              ...newDataSource[index],
              receipt_document_type: value,
            };
            setDataSourceItemList((prevDataSource) => {
              const updatedDataSource = [...prevDataSource];
              updatedDataSource[index] = {
                ...updatedDataSource[index],
                receipt_document_type: value,
              };
              return updatedDataSource;
            });
            setDataSourcePurchase(newDataSource);
          }}
          style={{ width: '100%' }}
          options={[
            { value: 'Purchase Invoice', label: t.purchaseInvoice },
            { value: 'Purchase Receipt', label: t.PurchaseReceipts },
          ]}
        />
      ),
    },
    {
      title: t.receiptDocument,
      dataIndex: 'receipt_document',
      render: (text, record, index) => (
        <Select
          placeholder={t.receiptDocument}
          value={record.receipt_document}
          popupMatchSelectWidth={false}
          showSearch
          onSearch={(value) => {
            if (
              dataSourcePurchase[index]?.receipt_document_type ===
              'Purchase Invoice'
            ) {
              setSearchTxt(value);
            } else {
              setSearchTxtRec(value);
            }
          }}
          filterOption={false}
          allowClear
          onClear={() => {
            setSearchTxt('');
            setSearchTxtRec('');
          }}
          onChange={async (value, option) => {
            handleGetDetails(value);
            setSelectedIndex(index);
            setDocId(value);
            const newDataSource = [...dataSourcePurchase];
            newDataSource[index] = {
              ...newDataSource[index],
              receipt_document: value,
              description: option?.option?.description,
            };
            setDataSourcePurchase(newDataSource);
            setDataSourceItemList((prevDataSource) => {
              const updatedDataSource = [...prevDataSource];
              updatedDataSource[index] = {
                ...updatedDataSource[index],
                receipt_document: value,
                description: option?.option?.description,
              };
              return updatedDataSource;
            });
          }}
          style={{ width: '100%' }}
          options={
            dataSourcePurchase[index]?.receipt_document_type ===
            'Purchase Invoice'
              ? PurchaseInvoice?.message?.map((item) => ({
                  value: item?.value,
                  label: item?.value,
                  option: item,
                }))
              : choiceFrom?.message?.map((item) => ({
                  value: item?.value,
                  label: item?.value,
                  option: item,
                })) || []
          }
        />
      ),
    },
    {
      title: t.Supplier,
      dataIndex: 'supplier',
      render: (text, record, index) => (
        <Select
          placeholder={t.Supplier}
          showSearch
          style={{ width: '100%' }}
          disabled={
            watchDistributeCharges === 'Distribute Manually' ? false : true
          }
          value={record.supplier}
          popupMatchSelectWidth={false}
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label ?? '').toLocaleLowerCase().includes(input)
          }
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? '')
              .toLowerCase()
              .localeCompare((optionB?.label ?? '').toLowerCase())
          }
          onChange={(value, option) => {
            setSelectedIndex(index);
            const newDataSource = [...dataSourcePurchase];
            newDataSource[index] = {
              ...newDataSource[index],
              supplier: value,
            };
            setDataSourcePurchase(newDataSource);
          }}
          options={suppliers?.data?.map((item) => ({
            value: item?.supplier_name,
            label: item?.name,
          }))}
        />
      ),
    },
    {
      title: t.postingDate,
      dataIndex: 'posting_date',
      render: (text, record, index) => (
        <DatePicker
          placeholder={t.postingDate}
          format="YYYY-MM-DD"
          style={{ width: '100%' }}
          value={dayjs(record.posting_date)}
          disabled
        />
      ),
    },
    {
      title: t.grandTotal,
      dataIndex: 'grand_total',
      render: (text, record, index) => (
        <Input
          placeholder={t.grandTotal}
          value={record.grand_total}
          style={{ width: '100%' }}
          type="number"
          min={0}
          disabled
        />
      ),
    },
    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  // const handleAdd = () => {
  //   const newData = { key: count, due_date: dayjs(), invoice_portion: 100 };
  //   setDataSourcePurchase([...dataSourcePurchase, newData]);
  //   // setDataSourceItemList(
  //   //   (prevDataSource) => [...prevDataSource, { key: count}]
  //   // );
  //   setCount(count + 1);
  // };

  const handleAdd = () => {
    const newData = {
      key: count,
      due_date: dayjs(),
      invoice_portion: 100,
      description: 'New itemName',
      items: [
        {
          key: count,
        },
      ],
    };
    setDataSourcePurchase([...dataSourcePurchase, newData]);
    setDataSourceItemList((prevDataSource) => [
      ...prevDataSource,
      { key: count, description: 'New itemName' },
    ]);
    setCount(count + 1);
  };
  // const handleDelete = (key) => {
  //   const newDataSource = dataSourcePurchase.filter((item) => item.key !== key);
  //   setDataSourceItemList(
  //     (prevDataSource) => prevDataSource?.filter((item) => item.key !== key)
  //   )
  //   setDataSourcePurchase(newDataSource);
  // };
  const handleDelete = (key) => {
    const newDataSource = dataSourcePurchase.filter((item) => item.key !== key);
    setDataSourceItemList((prevDataSource) =>
      prevDataSource?.filter((item) => item.key !== key)
    );
    setDataSourcePurchase(newDataSource);
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSourcePurchase}
        columns={columns}
        pagination={{ hideOnSinglePage: true }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
    </Card>
  );
};

export default PurchaseReceipts;
